<script>
/**
 * 再資源化等パターン
 * 処分場処理方法
 */
import {mapActions} from "vuex";
import InfiniteRecycleDisposerAutoComplete from "@/driver/components/InfiniteRecycleDisposerAutoComplete.vue";
import InfiniteTraderLocationAutoComplete from "@/driver/components/InfiniteTraderLocationAutoComplete.vue";
import ItemAutocomplete from "@/driver/components/ItemAutocomplete.vue";
import Confirm from "@/components/Confirm.vue";
import ChooseTraderModal from "@/driver/components/ChooseTraderModal.vue";
import DisposalMethodModal
  from "@/driver/pages/masters/recycle_disposal_patterns/methods/modals/DisposalMethodModal.vue";
import DisposedItemModal from "@/driver/pages/masters/recycle_disposal_patterns/methods/modals/DisposedItemModal.vue";

export default {
  name: "MasterMethodForm",
  components: {
    DisposalMethodModal,
    DisposedItemModal,
    ChooseTraderModal,
    Confirm,
    InfiniteTraderLocationAutoComplete,
    InfiniteRecycleDisposerAutoComplete,
    ItemAutocomplete,
  },
  props: {
    targetId: {
      type: Number,
      default: null
    },
    referenceOnly: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      /**
       * @param form { Object } 登録項目
       * @property form.code コード
       * @property form.name
       * @property form.invisible
       * @property form.recycle_disposer_disposal_method_details
       */
      form: null,
      items: [],
      recycleDisposalMethods: [],
      recycleDisposedItems: [],
      enableTraderModal: false,

      headers: [
        { value: "api_id", text: "API-ID", width: "6%", align: "center" },
        { value: "before_disposal_ratio", text: "処分割合", width: "11%" },
        { value: "disposal_method", text: "処分方法", width: "17%" },
        { value: "after_disposal_ratio", text: "処理後割合", width: "11%" },
        { value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "28%" },
        { value: "final_disposal", text: "最終処分", width: "22%" },
        { value: "remove_action", text: "", width: "15%", align: "end" },
      ],
    }
  },
  watch: {},
  computed: {
    editableMode () {
      return !!this.targetId;
    },
    pageTitle () {
      if (this.referenceOnly) {
        return "詳細"
      } else if (this.targetId) {
        return "編集"
      } else {
        return "登録"
      }
    },
    /**
     * 削除を除くリストを再生成
     * @return {*[]}
     */
    active_items () {
      if (this.form) {
        return this.form.recycle_disposer_disposal_method_details.filter(method => !method._destroy)
      } else {
        return [];
      }
    }
  },
  created() {

    this.fetchItems().then((content) => {
      this.items = content.items;
    });

    this.reloadDisposedItemCallback();

    this.reloadDisposalMethodCallback()


    if (this.editableMode) {
      this.fetchEdit( { id: this.targetId }).then((content) => {

        this.form = content;
      })
    } else {
      this.fetchNew().then((content) => {
        console.log(content);
        this.form = content;
      })
    }

  },
  methods: {
    /**
     * 処分場処理方法
     */
    ...mapActions("DriverMasterRecycleDisposerDisposalMethod", {
      fetchNew: "new",
      fetchEdit: "edit",
      create: "create",
      update: "update",
      destroy: "destroy",
    }),

    /**
     * JWNET取扱品目
     */
    ...mapActions("DriverMasterSearchItem", {
      fetchItems: "fetchWholeItems",
    }),

    /**
     * 処理方法
     */
    ...mapActions("DriverMasterSearchRecycleDisposalMethod", {
      fetchRecycleDisposalMethods: "index",
    }),

    /**
     * 処理後物
     */
    ...mapActions("DriverMasterSearchRecycleDisposedItem", {
      fetchRecycleDisposedItems: "index",
    }),

    openChooseTraderModalClickEvent () {
      this.enableTraderModal = true;
    },

    /**
     * 追加ボタン クリックイベント
     * 再資源化処分場処理方法詳細へのデータ追加を行う.
     */
    addButtonClickEvent () {

      const recycleDisposedItem = this.recycleDisposedItems.find(item => item.value === this.form.recycle_disposed_item_id);
      const recycleDisposalMethod = this.recycleDisposalMethods.find(item => item.value === this.form.recycle_disposal_method_id);
      const member = {
        key: Date.now(),
        id: null,
        recycle_disposal_method_id: recycleDisposalMethod.value,
        recycle_disposal_method_name: recycleDisposalMethod.text,
        after_disposal_method_names: recycleDisposalMethod.after_disposal_method_names,
        before_disposal_ratio: null,
        recycle_disposed_item_id: recycleDisposedItem.value,
        recycle_disposed_item_parent_name: recycleDisposedItem.parent_name,
        recycle_disposed_item_name: recycleDisposedItem.text,
        after_disposal_ratio: null,
        final_disposal: recycleDisposedItem.after_type === 'after_recycling' || recycleDisposalMethod.has_final_disposal,
        method_has_final_disposal: recycleDisposalMethod.has_final_disposal,
        after_type: recycleDisposedItem.after_type,
        after_type_label: recycleDisposedItem.after_type_label,
        _destroy: false,
      };
      this.form.recycle_disposer_disposal_method_details.push(member);
      this.form.recycle_disposed_item_id = null;
      this.form.recycle_disposal_method_id = null;
    },

    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.validationObserver.validateWithInfo().then(({ isValid, errors }) => {
        if (isValid) {
          this.register();
        }
      })
    },

    /**
     * 閉じるボタン クリックイベント
     */
    cancelButtonClickEvent () {
      this.$router.push({ name: 'DriverMasterRecycleDisposalPatterns' });
    },

    /**
     * 削除ボタン クリックイベント
     */
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.destroy({ id: this.targetId }).then(() => {
            this.$router.push({ name: 'DriverMasterRecycleDisposalPatterns' });
          });
        }
      })
    },

    /**
     * 処分業者 コールバック
     * @param object { Object }
     */
    disposerChangedCallback (object) {

      if (!object) {
        this.form.disposer_id = null;
        this.form.disposer_location_id = null;
        this.form.disposer_location_code = null;
        return;
      }

      this.form.disposer_id = object.id;
    },

    chooseTraderCallback (item) {
      this.form.disposer_id = item.id;
      this.closeModal();
    },

    /**
     * 処分事業場 コールバック
     * @param object { Object }
     * @property object.id
     * @property object.code
     * @property object.parent_id
     * @property object.parent_type
     */
    disposerLocationChangeCallback (object) {

      if (!object) {
        this.form.disposer_location_id = null;
        this.form.disposer_location_code = null;
        return;
      }

      this.form.disposer_location_id = object.id;
      this.form.disposer_location_code = object.code;

      if (this.form.disposer_id !== object.parent_id) {
        this.form.disposer_id = object.parent_id;
      }

    },

    disposalMethodCallback (item) {
      this.form.recycle_disposal_method_id = item.id;
      this.$refs.recycleDisposalMethod.isMenuActive = false;
    },

    disposedItemCallback (item) {
      this.form.recycle_disposed_item_id = item.id;
      this.$refs.recycleDisposedItem.isMenuActive = false;
    },

    reloadDisposalMethodCallback () {
      this.fetchRecycleDisposalMethods().then((content) => {
        this.recycleDisposalMethods = content.recycle_disposal_methods;
      })
    },

    reloadDisposedItemCallback () {
      this.fetchRecycleDisposedItems().then((content) => {
        this.recycleDisposedItems = content.recycle_disposed_items;
      });
    },

    closeModal () {
      this.enableTraderModal = false;
    },

    /**
     * リストの洗い替え
     * @param items { Array }
     */
    replaceResultList (items) {
      this.form.recycle_disposer_disposal_method_details = items;
    },

    /**
     * 登録処理
     */
    register () {

      let _form = {
        code: this.form.code,
        name: this.form.name,
        disposer_id: this.form.disposer_id,
        disposer_location_code: this.form.disposer_location_code,
        invisible: this.form.invisible,
        sort_priority: this.form.sort_priority,
        item_ids: this.form.item_ids,
        recycle_disposer_disposal_method_details_attributes: [],
      }

      this.form.recycle_disposer_disposal_method_details.forEach((item, _) => {
        _form.recycle_disposer_disposal_method_details_attributes.push({
          id: item.id,
          recycle_disposal_method_id: item.recycle_disposal_method_id,
          before_disposal_ratio: item.before_disposal_ratio,
          recycle_disposed_item_id: item.recycle_disposed_item_id,
          after_disposal_ratio: item.after_disposal_ratio,
          final_disposal: item.final_disposal,
          _destroy: item._destroy,
        });
      });

      const payload = {
        recycle_disposer_disposal_method: _form
      };

      if (this.editableMode) {
        this.update({ id: this.targetId, params: payload }).then(() => {
          this.$router.push({ name: 'DriverMasterRecycleDisposalPatterns' });
        });
      } else {
        this.create({ params: payload }).then(() => {
          this.$router.push({ name: 'DriverMasterRecycleDisposalPatterns' });
        });
      }
    },
  }
}
</script>

<template>
  <div>
    <validation-observer
      ref="validationObserver"
    >
      <v-card flat rounded>

        <v-toolbar flat>
          <v-toolbar-title>処分場処理方法{{ pageTitle }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text v-if="form">
          <!-- コード, 非表示にする -->
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                name="コード"
                rules="required|alpha_num_only|max:10"
                class="requiredMark"
              >
                <v-text-field
                  v-model="form.code"
                  :disabled="referenceOnly"
                  :error-messages="errors"
                  dense
                  outlined
                  hide-details="auto"
                  clearable
                  persistent-placeholder
                  placeholder="例）M001"
                >
                  <template v-slot:label>
                    <span>コード</span>
                    <span class="ml-1">
                      ({{ form.code?.length || 0 }} / 10)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="8"
            >
              <v-checkbox
                v-model="form.invisible"
                :disabled="referenceOnly"
                label="非表示にする"
                hide-details="auto"
                persistent-placeholder
                class="d-inline-block"
                :class="{ 'mt-2': referenceOnly }"
              />
              <div
                v-if="form.recent_codes.length > 0 && !referenceOnly"
              >
                最近使用したコード:&nbsp;<strong>{{ form.recent_codes.join(', ') }}</strong>
              </div>
            </v-col>
          </v-row>
          <!-- /コード, 非表示にする -->

          <!-- パターン名 -->
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                name="パターン名"
                rules="required|max:60"
                class="requiredMark"
              >
                <v-text-field
                  v-model="form.name"
                  :disabled="referenceOnly"
                  :error-messages="errors"
                  dense
                  outlined
                  hide-details="auto"
                  clearable
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>パターン名</span>
                    <span class="ml-1">
                      ({{ form.name?.length || 0 }} / 60)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /パターン名 -->

          <!-- 処分業者, 処分事業場 -->
          <v-row>
            <v-col cols="12">
              <h4 class="primary--text">処分事業者を選択</h4>
            </v-col>

            <v-col cols="12" md="4">
              <infinite-recycle-disposer-auto-complete
                :disposer-id="form.disposer_id"
                :location-id="form.disposer_location_id"
                :disabled="referenceOnly || editableMode"
                with-none-reporting
                without-invisible
                with-none-subscribe
                required
                @update:values="disposerChangedCallback"
              >
                <template v-slot:append-outer>
                  <v-btn
                    :disabled="referenceOnly || editableMode"
                    color="primary"
                    @click="openChooseTraderModalClickEvent"
                  >
                    選択
                  </v-btn>
                </template>
                <template v-slot:item="{ item }">
                  <v-chip
                    color="#e0ffff"
                    drak
                    label
                    small
                  >
                    {{ item.type === 'Trader::FinalDisposer' ? item.code : item.subscriber_number }}
                  </v-chip>&nbsp;
                  {{ item.text }}&nbsp;
                </template>
              </infinite-recycle-disposer-auto-complete>
            </v-col>
            <v-col cols="12" md="4">
              <infinite-trader-location-auto-complete
                :trader-id="form.disposer_id"
                :location-id="form.disposer_location_id"
                :disabled="referenceOnly || editableMode"
                chose-one
                label="処分事業場"
                required
                search-type="trader"
                with-final-disposer
                without-invisible
                permit-number-registered-only
                @update:values="disposerLocationChangeCallback"
              >
                <template v-slot:item="{ item }">
                  <v-chip
                    color="#e0ffff"
                    drak
                    label
                    small
                  >
                    {{ item.code }}
                  </v-chip>&nbsp;
                  {{ item.text }}&nbsp;
                </template>
              </infinite-trader-location-auto-complete>
            </v-col>
          </v-row>
          <!-- /処分業者, 処分事業場 -->

          <!-- 処分場処理方法 -->
          <v-row>
            <v-col cols="12">
              <h4 class="primary--text">処分場処理方法</h4>
            </v-col>
          </v-row>
          <v-sheet
            :outlined="!referenceOnly && !editableMode"
            rounded
          >
            <!-- 処分方法, 処理後物, 追加ボタン -->
            <v-row
              v-if="!referenceOnly && !editableMode"
              dense
              class="mt-3"
            >
              <v-col
                cols="12"
                md="4"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="処分方法"
                >
                  <v-autocomplete
                    ref="recycleDisposalMethod"
                    v-model="form.recycle_disposal_method_id"
                    :error-messages="errors"
                    :items="recycleDisposalMethods"
                    clearable
                    dense
                    hide-details="auto"
                    label="処分方法"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:append-outer>
                      <disposal-method-modal
                        @reload="reloadDisposalMethodCallback"
                        @close="reloadDisposalMethodCallback"
                        @selected="disposalMethodCallback"
                      />
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item two-line class="px-1" style="min-height: 50px">
                        <v-list-item-content class="py-0">
                          <v-list-item-title class="mb-0">
                            <div class="font-weight-medium">{{ item.text }}</div>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <div class="text-caption text-grey-600">
                              {{ item.after_disposal_method_names?.join('/')  }}
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <template v-if="false">
                        <div>{{ item.text }}</div><br />
                        <div><small class="text--disabled">{{ item.after_disposal_method_names?.join('/') }}</small></div>

                      </template>
                    </template>
                  </v-autocomplete>
                </validation-provider>
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="処理後物"
                >
                  <v-autocomplete
                    ref="recycleDisposedItem"
                    v-model="form.recycle_disposed_item_id"
                    :error-messages="errors"
                    :items="recycleDisposedItems"
                    clearable
                    dense
                    hide-details="auto"
                    label="処理後物"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:append-outer>
                      <disposed-item-modal
                        @reload="reloadDisposedItemCallback"
                        @close="reloadDisposedItemCallback"
                        @selected="disposedItemCallback"
                      />

                      <v-btn
                        :disabled="!form.recycle_disposal_method_id || !form.recycle_disposed_item_id"
                        class="ml-2"
                        color="primary"
                        @click="addButtonClickEvent"
                      >
                        &emsp;処分方法を追加&emsp;
                        <v-icon small>mdi-chevron-double-down</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-chip
                        small
                        :color="item.after_type === 'after_industrial' ? 'light-blue lighten-4' : 'light-green lighten-4' "
                      >
                        {{ item.after_type_label }}
                      </v-chip>
                      <span class="ml-3">{{ item.text }}</span>
                    </template>
                  </v-autocomplete>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /処分方法, 処理後物, 追加ボタン -->

            <!-- 工程 -->
            <v-row v-if="active_items">
              <v-col>
                <validation-provider
                  v-slot="{ errors: detailErrors }"
                  name="リスト"
                  :rules="{
                    pMLength: { targetList: active_items },
                    pMFull: { targetList: active_items }
                  }"
                >
                  <div class="hidden">
                    <v-input
                      v-model="form"
                      :error-messages="detailErrors"
                      dense
                      outlined
                      readonly
                      hide-details="auto"
                    >
                      <template v-slot:message>
                        <div class="ml-2">
                          <p v-for="(message, index) in detailErrors" :key="index">{{ message }}</p>
                        </div>
                      </template>
                    </v-input>
                  </div>

                  <recycle-step-table
                    :headers="headers"
                    :result-list.sync="form.recycle_disposer_disposal_method_details"
                    :has-error="detailErrors.length > 0"
                    :editable-mode="editableMode"
                    :reference-only="referenceOnly"
                    :hide-origin-ratio="true"
                    call-source="masterMethod"
                    @replace:list="replaceResultList"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /工程 -->
          </v-sheet>
          <!-- /処分場処理方法 -->

          <!-- 取扱品目 -->
          <v-row>
            <v-col cols="12">
              <h4 class="primary--text">処分前廃棄物種類</h4>
            </v-col>
            <v-col cols="12" md="8">
              <item-autocomplete
                v-model="form.item_ids"
                :disabled="referenceOnly"
                :items="items"
                label="取扱品目"
                multiple
                clearable
                chips
                small-chips
                deletable-chips
                dense
                hide-details="auto"
                outlined
                persistent-placeholder
                classes="target-items-select"
              />
            </v-col>
          </v-row>
          <!-- 取扱品目 -->
          <!-- 表示順 -->
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ numeric: true, min_value: 0, max_value: 99999 }"
                name="表示順"
              >
                <v-text-field
                  v-model="form.sort_priority"
                  :disabled="referenceOnly"
                  :error-messages="errors"
                  :show-size="1000"
                  dense
                  label="表示順"
                  outlined
                  hide-details="auto"
                  persistent-placeholder
                  reverse
                  type="number"
                  @keydown.69.prevent
                />
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /表示順 -->

        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn
            v-if="referenceOnly"
            :disabled="!form"
            color="error"
            @click="deleteButtonClickEvent"
          >
            削除
          </v-btn>
          <v-spacer />
          <v-btn
            @click="cancelButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            v-if="!referenceOnly"
            :disabled="!form"
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
    <confirm ref="confirm" />
    <choose-trader-modal
      :enable="enableTraderModal"
      search-type="trader"
      without-invisible
      include-final-disposer
      permit-number-registered-only
      @close="closeModal"
      @selected="chooseTraderCallback"
    />
  </div>
</template>

<style scoped lang="scss">
.error-border {
  border-width: 2px !important;
}
</style>
<style lang="scss">
.recycle_disposed_item_id {
  .v-input__append-outer {
  }
}
</style>
